CheckoutV2.PaymentV2.CreditCard = function(checkout, $container) {
    var method = this;

    this.mode = null;

    this.btInputMap = {
        'number'         : "card_number",
        'cvv'            : "cvv",
        'expirationDate' : "expire_date",
    };
    this.btCardTypeMap = {
        'Visa'             : "visa",
        'MasterCard'       : "mastercard",
        'American Express' : "amex",
        'Discover'         : "discover",
        'JCB'              : "jcb",
        'Maestro'          : "maestro",
    };

    this._init = function() {
        // Load the first stored payment if they exist instead of the CC form
        var storedPayments = method._getCards();
        // Because this is used as the initial method on a fresh checkout process, only change the
        // next step button text if we're actually on the payment step
        if(checkout.currentStepName() === 'payment') {
            method.setNextStepButtonHtml();
        }

        // If the incoming card is a single new card from addedCards, load up the new card.
        if(storedPayments.length === 1 && storedPayments[0].id.indexOf('newcard-') !== -1){
            method.mode = new CheckoutV2.PaymentV2.CreditCard.New(checkout, $container);
        } else if(storedPayments.length > 0) {
            // We have multiple stored payments between user account methods and addedCards
            method.mode = new CheckoutV2.PaymentV2.CreditCard.Stored(checkout, $container);
        } else {
            // User has nothing or is a guest.
            method.mode = new CheckoutV2.PaymentV2.CreditCard.New(checkout, $container);
        }

        method._listen();
    };

    this._listen = function() {
    };

    // Called by checkout and the method to set the next step button text
    this.setNextStepButtonHtml = function() {
        checkout.payment.setNextStepCTA(checkout.getReviewStepCTA());
        checkout.payment.setNextStepButtonHtml(checkout.getReviewStepButtonHtml());
    };

    this.prepareData = function( payment, callback ) {
        if ( ! payment.hostedFieldsInterface ) return callback();
        if ( payment.nonce )                   return callback();

        payment.hostedFieldsInterface.tokenize( function( err, payload ) {
            payment.card_number = 1;
            payment.expire_date = 1;
            payment.cvv = 1;
            payment.nonce = 0;

            if ( err ) {
                console.error( "Failed to tokenize", err );

                if( err.details ) {
                    $.each( err.details.invalidFieldKeys, function( i, btFieldKey ) {
                        var fieldName = method.btInputMap[ btFieldKey ];
                        if( fieldName ) payment[ fieldName ] = 0;
                    } );
                }
                else if ( err.code == "HOSTED_FIELDS_FIELDS_EMPTY" ) {
                    payment.card_number = 0;
                    payment.expire_date = 0;
                    payment.cvv = 0;
                }
            }
            else {
                payment.nonce = payload.nonce
                payment.last_four = payload.details.lastFour;
                var cardType = method.btCardTypeMap[ payload.details.cardType ]
                            || payload.details.cardType;
                payment.type = cardType;
            }

            callback();
        } );
    };

    this.resetValidity = function ( payment ) {
        // hosted fields need to be validated each time
        if ( payment.hostedFieldsInterface ) checkout.payment.onMethodInvalid();
    };

    this.destroy = function() {
        method.mode.destroy();
    };

    // This is copied all over the place. Make one in payment I think for use all over
    this._getCards = function() {
        var cards = [];

        // Grab stored payments from session
        checkout.session.get('storedPayments').forEach(function(card) {
            if (!card.method.match(/creditcard/)) 
               return;
            var payment = checkout.payment.models.paymentMethodFromStoredCard(card, checkout.cart.totals.values.total);
            cards.push(payment);
        });

        // Also add any cards added through the add card modal
        checkout.payment.getAddedCards().forEach(function(card) {
            cards.push(card);
        });

        return cards;
    };

    this._init();
};
